import React from 'react';
import { useAuth0 } from 'src/auth/useAuth0.hook';
import GraphQLRequestProvider from 'src/utils/graphQL/GraphQLRequestProvider';
import LoadingOrError from '../LoadingOrError/LoadingOrError';
import LoginDefaultSpinner from '../LoginDefaultSpinner/LoginDefaultSpinner';

type Props = {
  children: React.ReactNode;
};

const LoginAuthorization: React.FC<Props> = (props: Props) => {
  const { children } = props;
  const { isAuthenticated, loginWithRedirect, loading } = useAuth0();

  //Get the main screen loaded state
  if (!isAuthenticated && !loading) {
    if (loginWithRedirect) {
      loginWithRedirect({});
    }
  }

  return (
    <LoadingOrError loading={loading}>
      <GraphQLRequestProvider>{children}</GraphQLRequestProvider>
    </LoadingOrError>
  );
};

export default LoginAuthorization;
